import { render, staticRenderFns } from "./MoneyInfo.vue?vue&type=template&id=48d1c8f6&"
import script from "./MoneyInfo.vue?vue&type=script&lang=js&"
export * from "./MoneyInfo.vue?vue&type=script&lang=js&"
import style0 from "./MoneyInfo.vue?vue&type=style&index=0&id=48d1c8f6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports